import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await api.get(`/blog/slug/${slug}`);
        setPost(res.data);
      } catch (err) {
        console.error('Error al cargar post:', err);
      }
    };
    fetchPost();
  }, [slug]);

  if (!post) return <p className="text-center mt-10 text-gray-500">Cargando publicación...</p>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-16 font-[Manrope] grid md:grid-cols-3 gap-10">
      {/* Contenido del blog (izquierda) */}
      <div className="md:col-span-2">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{post.title}</h1>
        <div
          className="prose max-w-none text-gray-800"
          dangerouslySetInnerHTML={{ __html: post.content_html }}
        />
      </div>

      {/* Sidebar (derecha) */}
      <div className="space-y-6">
        {/* Imagen */}
        {post.cover_image && (
          <img
            src={`${API_URL}${post.cover_image}`}
            alt={post.title}
            className="rounded-lg w-full object-cover shadow-md"
          />
        )}

        {/* Publicación */}
        <div>
          <p className="text-sm text-gray-500">Publicado el</p>
          <p className="text-base font-medium text-gray-700">
            {new Date(post.published_at).toLocaleDateString()}
          </p>
        </div>

        {/* Categorías */}
        {post.categories && (
          <div>
            <p className="text-sm text-gray-500">Categorías</p>
            <div className="flex flex-wrap gap-2 mt-1">
              {post.categories.split(',').map((cat, i) => (
                <span
                  key={i}
                  className="inline-block px-2 py-1 text-xs rounded-full bg-gray-200 text-gray-700"
                >
                  {cat.trim()}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPost;
